"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorLink = exports.ErrorItem = exports.ErrorList = exports.SummaryHeader = exports.SummaryBox = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../../../Layout/Box"));

var _Anchor = _interopRequireDefault(require("../../Anchor"));

var _List = _interopRequireDefault(require("../../List"));

var _Heading = _interopRequireDefault(require("../../Heading"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SummaryBox = (0, _styledComponents.default)(_Box.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.SummaryBox = SummaryBox;
SummaryBox.displayName = 'SummaryBox';
SummaryBox.defaultProps = {
  p: '4',
  mb: '2',
  bg: '#ececec'
};
var SummaryHeader = (0, _styledComponents.default)(_Heading.default)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.SummaryHeader = SummaryHeader;
SummaryHeader.displayName = 'SummaryHeader';
SummaryHeader.defaultProps = {
  fontSize: '6',
  mb: '3'
};
var ErrorList = (0, _styledComponents.default)(_List.default)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  margin-bottom: 0;\n"], ["\n  margin-bottom: 0;\n"])));
exports.ErrorList = ErrorList;
ErrorList.displayName = 'ErrorList';
var ErrorItem = (0, _styledComponents.default)(_List.default.Item)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
exports.ErrorItem = ErrorItem;
ErrorItem.displayName = 'ErrorItem';
var ErrorLink = (0, _styledComponents.default)(_Anchor.default)(templateObject_5 || (templateObject_5 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.ErrorLink = ErrorLink;
ErrorLink.displayName = 'ErrorLink';
ErrorLink.defaultProps = {
  fontSize: '4'
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;